import script from "./GameDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./GameDetail.vue?vue&type=script&setup=true&lang=js"

import "./GameDetail.vue?vue&type=style&index=0&id=81608316&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-81608316"]])

export default __exports__